
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/food-beverage",
      function () {
        return require("private-next-pages/business/food-beverage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/food-beverage"])
      });
    }
  